import React, { Component } from 'react';

export default function Footer() {
   
        return (
            <>

                <div className='footer p-3'>
                    <p className='m-0'>Copyright © 2004- 2022</p>
                </div>
            </>

        )
    }
